import { render, staticRenderFns } from "./inner.vue?vue&type=template&id=989399fe&scoped=true&"
import script from "./inner.vue?vue&type=script&lang=js&"
export * from "./inner.vue?vue&type=script&lang=js&"
import style0 from "./inner.vue?vue&type=style&index=0&id=989399fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "989399fe",
  null
  
)

export default component.exports